import { render, staticRenderFns } from "./MeshFolderEditFrameDialog.vue?vue&type=template&id=c65073ca"
import script from "./MeshFolderEditFrameDialog.vue?vue&type=script&lang=js"
export * from "./MeshFolderEditFrameDialog.vue?vue&type=script&lang=js"
import style0 from "./MeshFolderEditFrameDialog.vue?vue&type=style&index=0&id=c65073ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports